import { Outlet } from 'react-router-dom'

import { useAsyncData } from 'modules/core/hooks/useAsyncData'
import { useStrictParams } from 'modules/core/hooks/useStrictParams'
import legalEntities from 'modules/core/store/collections/legalEntities'

import employeeGroups from 'modules/employees/store/collections/employeeGroups'
import CollectionsBootstrap from 'modules/legal_entities/lib/SettingsCollectionsBootstrap'

const RootPage = () => {
  const { id: entityId } = useStrictParams<'id'>()
  const { loading } = useAsyncData(
    () => Promise.all([employeeGroups.fetch(), legalEntities.fetch()]),
    []
  )
  const legalEntity = legalEntities.get(Number(entityId))

  return (
    <CollectionsBootstrap>
      <Outlet
        context={{
          loading,
          legalEntity,
        }}
      />
    </CollectionsBootstrap>
  )
}

export default RootPage
